import * as React from 'react';
import {
    ComboBox,
    FontIcon,
    IComboBox,
    IComboBoxOption,
    IComboBoxProps,
    Icon,
    IRefObject,
    Label,
    mergeStyles,
    mergeStyleSets,
    NeutralColors,
    SharedColors,
} from "@fluentui/react";
import { KeyboardEventHandler } from "react";
import { IItemComboBaseDTO } from '../../interfaces/base/IBase';

interface IComboBoxIDS extends IComboBoxProps {
    componentRef?: IRefObject<IComboBox>;
    onClick?: () => void;
    KeyUp?: KeyboardEventHandler<IComboBox> | undefined;
    onChange?: (
        event: React.FormEvent<IComboBox>,
        option?: IComboBoxOption,
        index?: number,
        value?: string
    ) => void;

    title?: string;
    useComboBoxAsMenuWidth?: boolean;
    description?: boolean;
    options: IItemComboBaseDTO[];

}

const iconClass = mergeStyles({
    fontSize: 12,
    // height: 50,
    // width: 50,
    // margin: '5px 0 0',
});

const classNames = mergeStyleSets({
    greenYellow: [{ color: SharedColors.orangeYellow20 }, iconClass],
});

const ComboBoxBase = (props: IComboBoxIDS) => {
    const { title, KeyUp, onChange, onClick, ...comboBoxProps } = props;

    const comboBoxStyles = {
        optionsContainer: {
            maxHeight: '200px',
            overflowY: 'auto',
        },
    };

    const selectedOption = React.useMemo(() => {
        return props.options?.find(option => option.key === props.selectedKey)?.descripcionTurno || '';
    }, [props.options, props.selectedKey]);

    return (
        <div>
            <Label required={props.required}>{props.title}</Label>
            <ComboBox
                autoComplete={"off"}
                componentRef={props.componentRef}
                allowFreeform
                openOnKeyboardFocus
                useComboBoxAsMenuWidth={
                    props.useComboBoxAsMenuWidth != null &&
                        props.useComboBoxAsMenuWidth != undefined
                        ? props.useComboBoxAsMenuWidth
                        : true
                }
                selectedKey={props.selectedKey}
                // errorMessage={selectedOption}
                styles={props.options.length > 5 ? comboBoxStyles : undefined}
                onKeyUp={props.KeyUp}
                onChange={props.onChange}
                onClick={props.onClick}
                {...comboBoxProps}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: '.1rem', fontSize: '12px', marginTop: '5px' }}>
                <div hidden={selectedOption === ''}>
                    <Icon iconName='Warning12' className={classNames.greenYellow} />
                </div>
                <div style={{ color: 'rgb(164, 38, 44)' }} hidden={!props.description}> {selectedOption}</div>
            </div>
        </div>
    );
};

export { ComboBoxBase }